import { createSelector } from '@reduxjs/toolkit'
import { selectJBPSettingsCurrentFYear } from 'legacy/lut/features/partner360/jbpSettings'

import { selectMarketYoyGrowthSelectedFYear } from './selectMarketYoyGrowthSelectedFYear'

export const selectIsMarketYoyGrowthPreviousFYearSelected = createSelector(
  [selectMarketYoyGrowthSelectedFYear, selectJBPSettingsCurrentFYear],
  (selectedFYear, currentFYear) => selectedFYear !== currentFYear
)
